export default {
  data () {
    return {
      isDesktop: false,
      isMobile: false
    };
  },
  mounted () {
    if (process.browser) {
      this.$nextTick(function () {
        window.addEventListener('resize', this.$_calculateWindowParams);
        this.$_calculateWindowParams();
      });
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.$_calculateWindowParams);
  },
  methods: {
    $_calculateWindowParams () {
      const width = document.documentElement.clientWidth;
      this.isDesktop = width >= 768;
      this.isMobile = width < 768;
    }
  }
};
